import { useSelector } from 'react-redux';

import {
    getGridSourceSetAction,
    getPreviewCreatorLevel,
} from '../../../../selectors';

export const useCreatorLevel = () => useSelector(getPreviewCreatorLevel);
export const useSourceSetAction = () => useSelector(getGridSourceSetAction);
